import React from 'react'

const FeederIcon = props => (
  <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.4"
      d="M5.77198 1.76788C5.42587 1.424 4.86457 1.42422 4.51947 1.76923L0.924066 5.36483C0.57829 5.71062 0.57829 6.27339 0.924066 6.61962L3.04527 8.74077C3.39094 9.08656 3.95369 9.08633 4.29947 8.74055L7.89498 5.14494C8.23986 4.79983 8.24053 4.23896 7.89699 3.89306L5.77198 1.76788ZM2.05215 6.172L1.53785 5.65791L1.7753 5.42056L2.2896 5.93465L2.05215 6.172ZM3.13759 5.73625L2.29844 4.89763L2.53579 4.66006L3.37494 5.4989L3.13759 5.73625ZM3.57356 4.65111L3.05926 4.13713L3.2966 3.89967L3.8109 4.41364L3.57356 4.65111ZM4.65856 4.21513L3.81986 3.3764L4.0572 3.13894L4.89602 3.97766L4.65856 4.21513ZM5.09442 3.12943L4.58045 2.61556L4.8178 2.37821L5.33176 2.89208L5.09442 3.12943ZM9.33594 1.20814L9.27943 1.0912L9.51879 0.852168C9.71338 0.657454 9.71338 0.34054 9.51879 0.145938C9.32419 -0.0486645 9.00739 -0.0486645 8.81246 0.14605L8.57366 0.384854L8.45661 0.328342C7.87305 0.0462306 7.175 0.0888662 6.63016 0.427042L7.01129 0.808189L6.77395 1.04565L6.25786 0.529547C6.17427 0.445954 6.06326 0.399961 5.94521 0.399961C5.82704 0.399961 5.71614 0.445954 5.63266 0.529547C5.54907 0.613028 5.50308 0.723813 5.50331 0.841649C5.50331 0.959708 5.54941 1.07083 5.63289 1.15442L8.50999 4.0316C8.68243 4.20405 8.96275 4.20416 9.13507 4.03194C9.30729 3.8596 9.30707 3.57917 9.13474 3.40673L9.03783 3.30982L9.1353 3.18269C9.57239 2.61243 9.64915 1.85595 9.33594 1.20814Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="10.8559"
        y1="-10.8529"
        x2="0.664734"
        y2="10.1912"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default FeederIcon
